import { render, staticRenderFns } from "./ercodeImg.vue?vue&type=template&id=e8e45a1a&scoped=true&"
import script from "./ercodeImg.vue?vue&type=script&lang=js&"
export * from "./ercodeImg.vue?vue&type=script&lang=js&"
import style0 from "./ercodeImg.vue?vue&type=style&index=0&id=e8e45a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e45a1a",
  null
  
)

export default component.exports